import { ParcelSizeIcon } from "assets/icons";
import { If } from "components";
import { useBoolean } from "hooks";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Pagination, SearchInput } from "ui";

import {
  DeleteDeliveryZoneModal,
  DeliveryFeesTable,
  ParcelSizesModal
} from "../../../../components";
import { useDeliveryFeesList } from "../../../../hooks";
import { FeesTabContentProps } from "./FeesTabContent.types";

import styles from "./FeesTabContent.module.scss";

const FeesTabContent = ({ onEditFeePress }: FeesTabContentProps) => {
  const { t } = useTranslation();

  const {
    deliveryFees,
    refetchDeliveryFees,
    isLoading,
    page,
    setPage,
    totalItems,
    sorting,
    setSorting,
    searchValue,
    setSearchValue
  } = useDeliveryFeesList();

  const [deletingZoneId, setDeletingZoneId] = useState<string | null>(null);

  const {
    value: isParcelSizesModalOpen,
    setTrue: openParcelSizesModal,
    setFalse: closeParcelSizesModal
  } = useBoolean(false);

  return (
    <>
      <div className={styles.tableHeader}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={"Search..."}
        />

        <Button
          variant="default"
          onClick={openParcelSizesModal}
          icon={<ParcelSizeIcon />}
        >
          {t("Set parcel sizes")}
        </Button>
      </div>

      <div className={styles.tableContainer}>
        <DeliveryFeesTable
          items={deliveryFees ?? []}
          refetchList={refetchDeliveryFees}
          isLoading={isLoading}
          setSorting={setSorting}
          sorting={sorting}
          onEditFeePress={onEditFeePress}
          onDeleteFeePress={(deliveryFee) =>
            setDeletingZoneId(deliveryFee.deliveryZoneId)
          }
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />

      <If condition={isParcelSizesModalOpen}>
        <ParcelSizesModal
          isOpen={isParcelSizesModalOpen}
          onClose={closeParcelSizesModal}
        />
      </If>

      <If condition={deletingZoneId}>
        <DeleteDeliveryZoneModal
          isOpen={!!deletingZoneId}
          onClose={() => setDeletingZoneId(null)}
          onDeleteSuccess={refetchDeliveryFees}
          id={String(deletingZoneId)}
        />
      </If>
    </>
  );
};

export default FeesTabContent;
